/* eslint-disable prettier/prettier */
import Badge from './badge.svg'
import Blanche from './blanche.svg'
import Close from './close.svg'
import Corn from './corn.svg'
import Dish from './dish.svg'
import Notebook from './notebook.svg'
import Play from './play.svg'

export default {
  'badge': Badge,
  'blanche': Blanche,
  'close': Close,
  'corn': Corn,
  'dish': Dish,
  'notebook': Notebook,
  'play': Play,
}